import { render, staticRenderFns } from "./TrainingOverview.vue?vue&type=template&id=5451caae&scoped=true&"
import script from "./TrainingOverview.vue?vue&type=script&lang=ts&"
export * from "./TrainingOverview.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingOverview.vue?vue&type=style&index=0&id=5451caae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451caae",
  null
  
)

export default component.exports